var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name, _vm.spacing],style:(_vm.mainCssVars)},[_c('grid',{class:[{ 'grid--container': !_vm.fullwidth }, `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__grid-content`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},[(_vm.cms.eyebrow)?_c('a-eyebrow',{class:`${_vm.name}__eyebrow`,attrs:{"cms":_vm.cms}}):_vm._e()],1),_vm._v(" "),(_vm.cms.underline)?_c('grid-item',{class:[
        `${_vm.name}__grid-item`,
        `${_vm.name}__grid-content`,
        `${_vm.name}__underline`,
      ],attrs:{"layout":[{ size: 1, x: 1, width: 4 }]}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }